import React from 'react';
import { mockData } from '../mock';

const About = () => {
  return (
    <div className="px-6 sm:px-12 lg:px-20 pt-32 sm:pt-40 pb-20 sm:pb-24">
      <div className="max-w-[1200px] mx-auto">
        
        {/* Small Title - Minimal & Elegant */}
        <div className="mb-16 sm:mb-20 text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extralight text-black tracking-wide mb-6">
            {mockData.journey.title}
          </h2>
          <div className="w-12 h-px bg-black/30 mx-auto"></div>
        </div>

        {/* Editorial Collage Layout - Photos First */}
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          
          {/* Two photos side-by-side - Image-First Design */}
          <div className="lg:col-span-7 grid grid-cols-2 gap-6 sm:gap-8">
            {/* Photo 1 - Taller */}
            <div className="aspect-[3/5] bg-white border border-black/5 overflow-hidden shadow-sm">
              <img
                src={mockData.headshots.photo1}
                alt="Laura Gonzalez - Professional Portrait"
                className="w-full h-full object-cover hover:opacity-95 transition-opacity duration-500"
              />
            </div>
            
            {/* Photo 2 - Offset positioning for editorial feel */}
            <div className="aspect-[3/4] bg-white border border-black/5 overflow-hidden mt-12 sm:mt-20 shadow-sm">
              <img
                src={mockData.headshots.photo2}
                alt="Laura Gonzalez - Professional Portrait"
                className="w-full h-full object-cover hover:opacity-95 transition-opacity duration-500"
              />
            </div>
          </div>

          {/* Journey text - Small, elegant */}
          <div className="lg:col-span-5 flex items-center">
            <div className="space-y-8 sm:space-y-10">
              <p className="text-xs sm:text-sm font-light text-black/70 leading-loose tracking-wide">
                {mockData.journey.content}
              </p>
              
              {/* Minimal signature */}
              <div className="pt-6 border-t border-black/10">
                <p className="text-[8px] sm:text-[9px] tracking-[2.5px] uppercase text-black/50 font-light">
                  Laura Gonzalez
                </p>
                <p className="text-[8px] sm:text-[9px] tracking-[2.5px] uppercase text-black/30 font-light mt-1">
                  Makeup Artist
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
